import { ChevronLeftIcon } from "lucide-react";
import { useTheme } from "@/b2b/context/ThemeContext";

export default function GoBackButton({ customBackSubmit }) {
  const theme = useTheme();

  return (
    <button
      onClick={() => {
        if (customBackSubmit) {
          customBackSubmit();
        } else {
          window.history.length > 0
            ? window.history.back()
            : window.location.replace("https://join.circlepe.in/");
        }
      }}
      className={`p-2 cursor-pointer hover:bg-opacity-80 se:w-8 se:h-8 sm:h-11 sm:w-11 rounded-full flex flex-col justify-center items-center transition-all duration-200
        ${
          theme?.borderColor
            ? `border ${theme?.borderColor}`
            : "bg-white border-gray-300 text-black"
        }`}
    >
      <ChevronLeftIcon
        className={`${theme?.headingColor ? theme.headingColor : "text-black"}`}
      />
    </button>
  );
}
